import 'whatwg-fetch';
import { detectIE } from '../../blocks_fss/js-helpers/detectIE';
import buttonPreloader from '../buttonPreloader/buttonPreloader';
import { tryAddEventListener } from '../../blocks_fss/js-helpers/js-helpers';

const renderSizeColumn = (hasSizeColumn, filesize) => {
    if (hasSizeColumn) {
        return `<span class="popup-table-column">${
            (filesize !== 'Size' && isNaN(filesize)) || parseFloat(filesize) === 0 ? '' : filesize
        }</span>`;
    }

    return '';
};

const renderItem = (
    { fileName, linkDisplayName, fileType, filesize, updatedOn, link },
    translations,
    hasSizeColumn,
) => {
    const linkFileName = fileName || '';
    return `
        <div class="popup-table-row ">
            <div class="popup-table-column">
                <div class="wrapper-file-icon">
                    <svg class="icon icon_pdf_ic ">
                        <use xlink:href="#crtf_ic"></use>
                    </svg>
                </div>
                <div>${linkDisplayName !== null ? linkDisplayName : linkFileName}</div>
            </div>
            <span class="popup-table-column">${fileType}</span>
            ${renderSizeColumn(hasSizeColumn, filesize)}
            <span class="popup-table-column">${updatedOn}</span>
            <span class="popup-table-column">
                <div class="download-btn-wrapper"><a class="download-link btn-se btn-se_color_blue"
                href="${link}${linkFileName}" download ${detectIE() ? 'target="_blank"' : ''}>
                    ${translations['pdp.label.download']}
                </a></div>
            </span>
        </div>
    `;
};

const renderTemplate = ({ img, partNumber, skuName }, { translations, downloadLinks }) => {
    const hasSizeColumn = downloadLinks.some(
        item => parseFloat(item.filesize) && parseFloat(item.filesize) !== 0,
    );

    return `
        <div class="popup-header">
            <div class="popup-header__img-wrapper">
                <img class="popup-header__img" src="${img}" />
            </div>
            <div class="popup-header-content">
                <div class="popup__product-name">${skuName}</div>
                <span class="popup-sku">${partNumber}</span>
            </div>
        </div>
        <div class="popup-content__files-content">
            <div class="content-header">${translations['finder.software.availableVersions']}</div>
            <div class="${
                hasSizeColumn ? 'popup-table' : 'popup-table popup-table_without-size-column'
            }">
                <div class="popup-table-row popup-table-row_head-row">
                    <div class="popup-table-column">
                        ${translations['software.download.fileTitle']}
                    </div>
                    <div class="popup-table-column">
                        ${translations['software.download.fileType']}
                    </div>
                    ${renderSizeColumn(hasSizeColumn, translations['software.download.fileSize'])}
                    <div class="popup-table-column">${translations['software.updatedOn']}</div>
                    <div class="popup-table-column"></div>
                </div>
                ${downloadLinks.map(item => renderItem(item, translations, hasSizeColumn)).join('')}
            </div>
        </div>
    `;
};

const closePopUp = () => {
    document.body.classList.remove('modal-open');
    document.querySelector('.popup-wrapper').style.display = 'none';
};

tryAddEventListener(document.querySelector('.popup-close'), 'click', () => {
    closePopUp();
});

tryAddEventListener(document.querySelector('.popup-wrapper'), 'click', e => {
    if (e.target.classList.contains('popup-wrapper')) {
        closePopUp();
    }
});

tryAddEventListener(window, 'keydown', e => {
    if (e.keyCode === 27 && document.body.classList.contains('modal-open')) {
        closePopUp();
    }
});

const handleResponse = (commonInfo, downloadItems) => {
    const popUpWrapper = document.querySelector('.popup-wrapper');
    popUpWrapper.style.display = 'block';
    popUpWrapper.scrollTo(0, 0);
    document.body.classList.add('modal-open');
    document.querySelector('.popup-content').innerHTML = renderTemplate(commonInfo, downloadItems);
};

/**
 * Creates and sends request to rest service to get all download files and information
 * returns es6 fetch
 * after successful resolve it calls handleResponse() class method
 * @param data {Object} - object contains additional common data for popup
 * ( img, sku name, partnumber)
 * @param element {Object} -  return  dom element for which we should show preloader
 */
const sendRequest = (data, element) => {
    const fetchHeaders = new Headers({ 'Content-Type': 'text/html' });
    const preloader = buttonPreloader(element);
    preloader.show();
    return fetch(data.url, {
        method: 'get',
        credentials: 'same-origin',
        headers: fetchHeaders,
        cache: 'default',
    })
        .then(response => {
            if (!response.ok) throw new Error(response.statusText);
            return response.json();
        })
        .then(result => {
            handleResponse(data, result);
            preloader.hide();
        })
        .catch(error => {
            console.error(error);
        });
};

const makeDownloadPopup = (popUpData, element) => {
    sendRequest(popUpData, element);
};
export default makeDownloadPopup;
